import { selectEntities, selectEntity } from '@hozana/api/selectors'

import type { TState } from 'config/types'

export const selectPrayerEvent = (state: TState, prayerEventId: number) =>
  selectEntity(state, 'prayerEvent', prayerEventId)

export const selectPrayerMeetings = (state: TState, prayerMeetingIds: number[]) =>
  selectEntities(state, 'prayerMeeting', prayerMeetingIds)
export const selectPrayerMeeting = (state: TState, prayerMeetingId: number) =>
  selectEntity(state, 'prayerMeeting', prayerMeetingId)
